import { customerExperiencesNavigationResource } from '@jira/router-resources__customer-experiences-navigation/src/customerExperiencesNavigationResource.tsx';
import { MenuIdCustomerExperiences } from '@jira/navigation-apps__constants/src/MenuIdCustomerExperiences.tsx';
import ErrorPagesNotFound from '@jira/router-routes__common/src/ui/error-pages/not-found/index.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { helpCenterSettingsAnalyticsRoute } from '@jira/router-routes__help-center-settings-routes/src/helpCenterSettingsAnalyticsRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { helpCenterSettingsAnalyticsRoutePageEntryPoint } from './ui/analytics/index.tsx';

export const helpCenterSettingsAnalyticsRouteEntry: Route = createEntry(
	helpCenterSettingsAnalyticsRoute,
	() => ({
		group: 'customer-service',
		perfMetricKey: 'customer-service.analytics',
		layout: globalLayout,
		navigation: {
			menuId: MenuIdCustomerExperiences,
		},
		// eslint-disable-next-line no-restricted-syntax
		component: ErrorPagesNotFound,
		entryPoint() {
			return helpCenterSettingsAnalyticsRoutePageEntryPoint;
		},
		resources: [
			...getNavigationResources(),
			// TODO: AVP route resources here
			customerExperiencesNavigationResource,
		],
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
